module.exports = __webpack_public_path__ + "img/fs.f0bb0872.png";